import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DBGrid = _resolveComponent("DBGrid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DBGrid, {
      store: _ctx.store,
      config: _ctx.config,
      ref: "grid"
    }, null, 8, ["store", "config"])
  ]))
}